import React, { PureComponent } from 'react';
import ContentLoader from 'react-content-loader';
import classes from './LoadingComponent.css';

const MyLoader = () => (
    <ContentLoader
                height={300}
                width={400}
                speed={1}
                primaryColor="#f3f3f3"
                secondaryColor="#ecebeb"
            >
                <rect x="0" y="0" rx="4" ry="4" width="250" height="20" /> 
                <rect x="0" y="30" rx="5" ry="5" width="380" height="100" /> 
                <rect x="0" y="150" rx="5" ry="5" width="300" height="10" /> 
                <rect x="0" y="170" rx="5" ry="5" width="300" height="10" /> 
                <rect x="0" y="190" rx="5" ry="5" width="300" height="10" /> 
                <rect x="0" y="230" rx="5" ry="5" width="300" height="10" /> 
                <rect x="0" y="250" rx="5" ry="5" width="300" height="10" />
    </ContentLoader>
)

export class LoadingComponent extends React.Component {
    render() { return <div className={classes.loadingList}>
            {MyLoader()}
    </div>}
}


// WEBPACK FOOTER //
// ./src/app/components/LoadingComponent.js